import { useAppStore } from '@/store'
import { isInternalEmail } from '@/utils/userUtils'

/**
 * Whether the signed-in user is Intuigence staff (an `@intuigence.ai` or
 * `@intuigence.com` email, see `isInternalEmail`).
 *
 * Engineer-facing diagnostics gate on this: the agent trace magnifying glass
 * in Board chat and in a workflow step's panel, and the `/kg-trace` page
 * itself. A customer's account never renders them. False until the session
 * has loaded a user, which `LoginProtectedRoute` guarantees before any gated
 * page mounts.
 */
export function useIsInternalUser(): boolean {
  return useAppStore((s) => isInternalEmail(s.user?.email))
}
